<template>
    <div class="dashboard">
        <template v-if="FRRPage">
            <dashboard-frr />
        </template>
        <template v-else-if="recoveryPage">
            <Dashboard-Recovery-Report />
        </template>
        <template v-else-if="catalogPage">
            <Dashboard-catalog />
        </template>
        <template v-else>
            <dashboard-content />
        </template>
    </div>
</template>
<script>
import DashboardContent from '@/components/views/DashboardContent';
import DashboardFrr from '@/components/views/FRRDashboardContent.vue';
import DashboardRecoveryReport from '@/components/views/RecoveryReportDashboard.vue';
import DashboardCatalog from '@/components/views/CatalogDashboard.vue';

export default {
    name: 'Dashboard',
    components: {
        DashboardContent,
        DashboardFrr,
        DashboardRecoveryReport,
        DashboardCatalog
    },
    data: function () {
        return {
            location:''
        };
    },
    computed: {
        FRRPage () {
            return window.location.href.toLowerCase().indexOf('frr') !== -1;
        },
        recoveryPage () {
            return window.location.href.toLowerCase().indexOf('recovery/reports') !== -1;
        },
        catalogPage () {
            return window.location.href.toLowerCase().indexOf('catalog') !== -1;
        },
    },
    mounted () {

        $(".introTextContainer").html($("#nodesdata").html());
        $("#textModal #textModal-label").html($("#textModal h3").html());
        $("#textModal .introTextContainer h3").remove();
        $("#textModal .categorical-spending-text").removeClass("categorical-spending-text");
        $("#nodesdata").remove();
    },
    methods: {

    }
};
</script>

<style lang="scss">
.dashboard {
    height: 100%;
    width: 100%;
}

</style>